import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'

export const isMobile: boolean = browserCheck.isMobile

const updates = { evening: 'Wird am Dienstag aktualisiert' }

const metaCases = 'Fälle'

export const localesHospitalMultiples = {
  title: 'Patients Covid-19 à l’hôpital',
  subline: (
    <>
      Les données de l’OFSP sur les capacités hospitalières ne sont plus
      actualisées depuis le 2 mai 2023.
    </>
  ),
  link: null,
  update: updates.evening,
  swissTitle: 'Suisse',
  keyHosp: 'Hospitalisé',
  keyIntensive: 'En soins intensifs',
  metaCases: metaCases,
  showMoreClosed: 'Voir tous les cantons',
  showMoreOpened: 'Voir une sélection de cantons',
  noData: 'Pas de données',
  emptyData: 'Pas de données',
  timerange: ['Période']
}
